<div class="ec-market-container" fxLayout="column" fxLayoutGap="30px" *appVar="hierarchyEntity|async as entity">
    <div fxLayout="row" fxLayoutAlign="start center">
        <button app-ghost-button (click)="goBack()">
            <app-icon name="fal-arrow-left"></app-icon>
            {{'Back to Community Total'|i18n}}
        </button>
    </div>
    <ng-container *ngIf="entity && isViewable(entity); else unviewableEntity">
        <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="30px" class="back-panel">
            <div class="top-panel">
                <app-filter-bar
                        [showNullData]="showNullData"
                        [config]="billingPeriodCfg"
                        [billingPeriod]="billingPeriod"
                        [useFilter]="true"
                        [showGSEBtn]="false"
                        (billingPeriodEventEmitter)="onChangeBillingPeriod($event)">
                </app-filter-bar>
            </div>
            <ng-container *ngIf="response; else loadingMarket">
                <div fxLayout="row" fxLayoutAlign="start stretch" fxLayoutGap="48px">
                    <div fxLayout="column" fxLayoutGap="30px" class="block" fxFlex="15">
                        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
                            <span class="txt-s-16-7">{{'Geographical zone'|i18n}}</span>
                            <app-icon icon-color-h name="fas-info-circle"
                                      [title]="('Portion of the national grid to which the aggregate belongs'|i18n)">
                            </app-icon>
                        </div>
                        <span class="geo-txt">{{response.zone}}</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="36px">
                        <app-icon icon-color-w name="fas-exclamation-triangle"
                                  *ngIf="hasError(EconomicsErrorType.MISSING_ZONAL_PRICE, response.errors) && showError(EconomicsErrorType.MISSING_ZONAL_PRICE, response.errors)"
                                  [title]="'Due to partial zonal price supply, we cannot show you complete economic data for this period. No action is required on your part.'|i18n">
                        </app-icon>
                        <mat-checkbox app-checkbox class="txt-p-14-4" [(ngModel)]="checks['Zone price']">{{'Zone price'|i18n}}</mat-checkbox>
                        <mat-checkbox app-checkbox class="txt-p-14-4" [(ngModel)]="checks['PUN']">{{'PUN'|i18n}}</mat-checkbox>
                        <mat-checkbox app-checkbox class="txt-p-14-4" [(ngModel)]="checks['Difference between zone price and PUN']">{{'Difference between zone price and PUN'|i18n}}</mat-checkbox>
                    </div>
                </div>
            </ng-container>
            <ng-container
                    *ngTemplateOutlet="charts; context: {quantities: quantities}">
            </ng-container>
        </div>
    </ng-container>

</div>


<ng-template #charts let-quantities="quantities">
    <div *ngIf="quantities" fxLayout="column" class="chart-quantities">
        <div *ngFor="let q of quantities;" fxLayout="column" fxLayoutAlign="start stretch">
            <div *ngIf="checks[q.name]" class="chart-container">
                <div fxLayout="row" fxLayoutAlign="space-between start" class="mt-12">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                        <span class="txt-b-18-7">{{q.name|i18n}}</span>
                    </div>
                    <div *ngIf="q.name === ZONE_PRICE_NAME">
                        <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="16px"
                             *appVar="q.percentage_stats[TimeSlot.ALL] as Stats">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
                                <div class="txt-p-14-4">{{('Minimum'|i18n) + ':'}}</div>
                                <div class="txt-h-14-7">{{Stats.min|niceValue:q.uom}}</div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
                                <div class="txt-p-14-4">{{('Medium'|i18n) + ':'}}</div>
                                <div class="txt-h-14-7">{{Stats.avg|niceValue:q.uom}}</div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
                                <div class="txt-p-14-4">{{('Maximum'|i18n) + ':'}}</div>
                                <div class="txt-h-14-7">{{Stats.max|niceValue:q.uom}}</div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="q.name === PUN_NAME">
                        <div fxLayout="column" fxLayoutGap="2px" fxLayoutAlign="end center">
                            <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="12px"
                                 *appVar="q.percentage_stats[TimeSlot.ALL] as Stats">
                                <span class="txt-h-16-7">{{('Single Hour'|i18n) + ':'}}</span>
                                <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="2px">
                                    <div class="txt-p-12-4">{{('Minimum'|i18n) + ':'}}</div>
                                    <div class="txt-h-12-7">{{Stats.min|niceValue:q.uom}}</div>
                                </div>
                                <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="2px">
                                    <div class="txt-p-12-4">{{('Medium'|i18n) + ':'}}</div>
                                    <div class="txt-h-12-7">{{Stats.avg|niceValue:q.uom}}</div>
                                </div>
                                <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="2px">
                                    <div class="txt-p-12-4">{{('Maximum'|i18n) + ':'}}</div>
                                    <div class="txt-h-12-7">{{Stats.max|niceValue:q.uom}}</div>
                                </div>
                            </div>
                            <div fxLayout="column" fxLayoutAlign="end center" fxLayoutGap="2px" class="align-end">
                                <div *ngFor="let timeSlot of q.percentage_stats | keyvalue" fxLayoutAlign="end center"
                                     class="align-end">
                                    <div *ngIf="timeSlot.key !== TimeSlot.ALL" fxLayout="row"
                                         fxLayoutAlign="space-between center" fxLayoutGap="8px">
                                        <span class="txt-h-16-7">{{(timeSlot.key) + ':'}}</span>
                                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="2px">
                                            <div class="txt-p-12-4">{{('Minimum'|i18n) + ':'}}</div>
                                            <div class="txt-h-12-7">{{timeSlot.value.min|niceValue:q.uom}}</div>
                                        </div>
                                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="2px">
                                            <div class="txt-p-12-4">{{('Medium'|i18n) + ':'}}</div>
                                            <div class="txt-h-12-7">{{timeSlot.value.avg|niceValue:q.uom}}</div>
                                        </div>
                                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="2px">
                                            <div class="txt-p-12-4">{{('Maximum'|i18n) + ':'}}</div>
                                            <div class="txt-h-12-7">{{timeSlot.value.max|niceValue:q.uom}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="q.name === ZONE_PUN_DIFFERENCE_NAME">
                        <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="16px"
                             *appVar="q.percentage_stats as Stats">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
                                <div class="txt-p-14-4">{{('Minimum'|i18n) + ':'}}</div>
                                <div class="txt-h-14-7">{{(Stats.min * 100)|niceValue:q.uom}}</div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
                                <div class="txt-p-14-4">{{('Medium'|i18n) + ':'}}</div>
                                <div class="txt-h-14-7">{{(Stats.avg * 100)|niceValue:q.uom}}</div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
                                <div class="txt-p-14-4">{{('Maximum'|i18n) + ':'}}</div>
                                <div class="txt-h-14-7">{{(Stats.max * 100)|niceValue:q.uom}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div [ngSwitch]="q.type" fxLayout="row" fxLayoutAlign="center" fxLayoutGap="1rem" class="mt-8">
                </div>
                <div *ngIf="q.data.length" class="chart-quantity">
                    <app-line-chart [data]="q.data"
                                    [margins]="{left:75, right: -20}"
                                    [yTickFormatter]="q.uom|yTickFormatter"
                                    [tooltipFormatter]="q.uom|tooltipFormatter:TIME_DELTA_HOUR"
                                    [xGrid]="true"
                                    [yGrid]="true"
                                    [gridColor]="gridColor"
                                    [tooltipBorderColor]="tooltipBorderColor"
                                    [tooltipBackgroundColor]="tooltipBackgroundColor"
                                    [selectionLineColor]="selectionLineColor"
                                    [xTickSpace]="80"
                                    [yTickSpace]="30"
                                    [resizeTrigger]="contentResize">
                    </app-line-chart>
                </div>
                <div *ngIf="!q.data.length" fxLayout="row" fxLayoutAlign="center" class="mt-24">
                    <app-icon icon-color-s name="fal-exclamation-circle"></app-icon>&nbsp;
                    <span class="pl-8">{{'No data'|i18n}}</span>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #loadingMarket>
    <div fxLayout="column" fxLayoutAlign="space-around center">
        <div fxLayout="row" fxLayoutAlign="center center" class="mt-24 mb-16">
            <mat-spinner app-spinner diameter="20"></mat-spinner>
            <span class="pl-8">{{ 'Loading'|i18n }}...</span>
        </div>
        <div *ngIf="showComputationWarning" fxLayout="row" fxLayoutAlign="center center"
             fxLayoutGap="30px" economics-warning class="mt-30 padding-14">
            <app-icon icon-color-w name="fas-info-circle"></app-icon>
            <div>{{ 'We are recalculating the economics data due to an updated configuration parameter.'|i18n }}</div>
        </div>
    </div>
</ng-template>

<ng-template #unviewableEntity>
    <div fxLayout="row" fxLayoutAlign="center" class="mt-16">
        {{'Insufficient permissions to view this resource'|i18n}}
    </div>
</ng-template>
